import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Divider, Paper, Stack, Typography } from '@mui/material';
import { BikeleasingConditionDTO, BikeleasingContractDetailsDTO, BikeleasingContractDetailsDTOStatusEnum } from 'probonio-shared-ui/api';
import { useBikeleasingPortalLinkBuilder } from 'probonio-shared-ui/utils/bikeleasingUrl';
import { useTranslation } from 'react-i18next';
import { ExternalLinkButton } from '../../../component/button/ExternalLinkButton';

export const YourAdvantages: React.FC<{ contract: BikeleasingContractDetailsDTO; condition: BikeleasingConditionDTO }> = props => {
  const { t } = useTranslation('benefitModule');
  const { status, id, insuranceCoverage } = props.contract;
  const { inspectionPackage } = props.condition;
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();

  const insurancePackageText = (() => {
    // Comfort package is always included, but doesn't exist in api model
    const codes = ['comfort', ...(insuranceCoverage ?? [])];
    const uniqueCodes = Array.from(new Set(codes));

    const labels = uniqueCodes.map(code =>
      t(`extensions:bikeleasing_v2.contract.insurance.packages.${code}`, { defaultValue: String(code) }),
    );

    return labels.length ? labels.join(', ') : '-';
  })();

  return (
    <Paper sx={{ mt: 1, pt: 1 }}>
      <Typography component="span" color="text.secondary" variant="caption" sx={{ paddingLeft: 1 }}>
        {t(`extensions:bikeleasing_v2_benefit.section.yourAdvantage`)}
      </Typography>
      <Stack paddingTop={1} paddingX={1} paddingBottom={0.5} display="flex" justifyContent="space-between" direction={'column'} gap={0.5}>
        <Stack direction={'row'} justifyContent="space-between" sx={{ width: '100%' }}>
          <Typography variant="caption" color="text.secondary">
            {t('extensions:bikeleasing_v2_benefit.contract.insuranceCoverage')}
          </Typography>
          <CheckCircleIcon color="success" />
        </Stack>
        <Stack direction={'column'} spacing={0.5} sx={{ width: '100%' }}>
          <Typography align="left">{insurancePackageText}</Typography>
        </Stack>
      </Stack>
      <Divider sx={{ mx: 1 }} />
      <Stack sx={{ px: 1, py: 0.5 }} display="flex" justifyContent="space-between" direction={'column'} gap={0.5}>
        <Typography variant="caption" color="text.secondary">
          {t('extensions:bikeleasing_v2_benefit.contract.insurance.wear')}
        </Typography>
        <Stack direction={'column'} spacing={0.5} sx={{ width: '100%' }}>
          <Typography align="left">
            {inspectionPackage?.conclusion ? t(`extensions:bikeleasing_v2_benefit.conclusion.${inspectionPackage.conclusion}`) : '-'}
          </Typography>
        </Stack>
      </Stack>
      {status === BikeleasingContractDetailsDTOStatusEnum.EmployeeApprovalRequired && (
        <Box sx={{ px: 1 }}>
          <ExternalLinkButton
            href={buildBikeleasingPortalLink(`/user/contracts/${id}?CHANGE_INSURANCE_PACKAGE=true`)}
            sx={{ mb: 1, mt: 0.5, textAlign: 'center' }}
            fullWidth
            variant="contained"
          >
            {t('extensions:bikeleasing_v2.contract.buttons.changeInsurancePackage')}
          </ExternalLinkButton>
        </Box>
      )}
    </Paper>
  );
};
